export interface ProductTypeDetails {
  id: string;
  description: string;
  userDescription: string;
  unitOfMeasureId: string;
  nominalCodeId: string;
  costCentreId: string;
  defaultWarehouseId: string;
  defaultLocationId: string;
  defaultGradeId: string;
  defaultMakeUpId: string;
  salesAllocationWarehouseId: string;
  maximumSize: number;
  defaultCommission: number;
  good: boolean;
  extra: boolean;
  delivery: boolean;
  sundry: boolean;
  fullyAllocate: boolean;
  saleable: boolean;
  purchasable: boolean;
  allocateAndDespatchTogether: boolean;
  splitBeforeDespatch: boolean;
  showNoOfItems: boolean;
  showNoOfItemsOnPurchaseOrder: boolean;
  workOutQuantityFromItemsPurchaseOrder: boolean;
  workOutQuantityFromItemsSalesOrder: boolean;
  holdStock: boolean;
  serviceType: boolean;
  keepExistingStockNumber: boolean;
  focQty: number;
  stockNoPrefix: string;
  useSizeMatrix: boolean;
  holdStockAtProductLevel: boolean;
  holdStockAtLocationLevel: boolean;
  holdStockAtBatchLevel: boolean;
  autoAllocateOnSalesOrder: boolean;
  autoAllocatePurchaseOrder: boolean;
  imperialMeasurements: boolean;
  inlineAllocation: boolean;
  hardAllocation: boolean;
  allocationTolerance: number;
  collateSubOrders: boolean;
  printCustomsSummary: boolean;
  printProductSummary: boolean;
  autoCreateDespatchNoteOnMultiPick: boolean;
  showOnDropDownInMultiPick: boolean;
  printStockLabelOnMultiPick: boolean;
  doNotAllowPick: boolean;
  keepExistingStockNoForProcessing: boolean;
  doNotPrintBomOnPurchaseOrder: boolean;
  processProductType: boolean;
  allowProcessing: boolean;
  returnableProduct: boolean;
  printAddressLabelOnMultiPick: boolean;
  printStockLabelOnReceiptOrCut: boolean;
  customerOrderOutOfStockMessage: string;
  sampleExtension: string;
  showOnCustomerOrder: boolean;
  remeasureBeforeCutting: boolean;
  obsolete: boolean;
}
